import { round } from 'lodash'

export const formatNumber = (number: number) => round(number, 2).toLocaleString('fr-FR').replace(',', '.')
